import './planner.css';

/**
 * Copy for the unified week candidate pool header.
 * @param {{ userPicksCount: number, recommendedCount: number, plannerState?: string }} opts
 */
function weekOptionsHeaderCopy({ userPicksCount, recommendedCount, plannerState = 'healthy' }) {
  const total = userPicksCount + recommendedCount;

  let title;
  if (userPicksCount > 0 && recommendedCount > 0) {
    title = `Week options · ${total}`;
  } else if (userPicksCount > 0) {
    title = `Your picks · ${total}`;
  } else {
    title = `Suggestions · ${total}`;
  }

  let subtitle = null;
  if (userPicksCount > 0 && recommendedCount > 0) {
    subtitle = `${userPicksCount} yours · ${recommendedCount} suggested`;
  } else if (recommendedCount > 0) {
    subtitle = plannerState === 'thin-library' ? '(pantry + prefs)' : '(pantry match)';
  } else if (userPicksCount > 0) {
    subtitle = 'Added from Recipes';
  }

  return { title, subtitle };
}

/**
 * Unified section header for planner candidate pool (picks + suggestions).
 */
export default function WeekOptionsHeader({
  userPicksCount,
  recommendedCount,
  plannerState = 'healthy',
  className = '',
  title: titleOverride = null,
  showSubtitle = true,
}) {
  const { title, subtitle } = weekOptionsHeaderCopy({
    userPicksCount,
    recommendedCount,
    plannerState,
  });

  return (
    <div className={className}>
      <div className="planner-divider">
        <div className="planner-divider-line" />
        <div className="planner-divider-label">{titleOverride || title}</div>
        <div className="planner-divider-line" />
      </div>
      {showSubtitle && subtitle && (
        <p className="planner-week-options-subtitle">{subtitle}</p>
      )}
    </div>
  );
}
